import PropTypes from 'prop-types';
import React from 'react';
import { MFChannel } from '../../../Components/SDK';
import { setActiveConversationChannel, useChannelIsMember } from '../../../Slice';
import { showErrorToast } from '../../utils';
import { navigateChannel } from '../../../Components/Layouts/Sidebar';
import { useDispatch } from 'react-redux';

function ChannelJoinButton({ channelId, className }) {
   const isMember = useChannelIsMember(channelId);
   const dispatch = useDispatch();
   const handleJoin = async () => {
      try {
         const res = await MFChannel.joinChannel({ channelId });
         if (res.statusCode !== 200) {
            showErrorToast(res?.message);
            return;
         }
         setTimeout(() => {
            navigateChannel?.current?.toRecentChannels();
            dispatch(setActiveConversationChannel({ channelId }));
         }, 300);
      } catch (error) {
         console.error('❌ Failed to join channel:', error);
      }
   };

   return (
      <a  key={channelId} disabled={isMember} onClick={handleJoin}>
         {isMember ? 'Followed' : 'Follow'}
      </a>
   );
}

export default ChannelJoinButton;

ChannelJoinButton.propTypes = {
   channelId: PropTypes.string.isRequired,
   className: PropTypes.string,
};
